export const STATUS =Object.freeze( {
    RH_FILTERS : 1,
    PENDING_TO_SCHEDULE : 2,
    SCHEDULED : 3,
    INTERVIEWED : 4,
    DISCARDED : 5,
    FINAL_CANDIDATE : 6,
    ONBOARD : 7,
    COLLABORATOR : 8,
    OFFER : 9,
    SCHEDULED_BY_HR : 10,
    HR_INTERVIEW : 11,
    SCHEDULED_BY_BOSS : 12,
    BOSS_INTERVIEW : 13,

})

    // rh_filters : 1,
    // pending_to_schedule : 2,
    // scheduled : 3,
    // interviewed : 4,
    // discarded : 5,
    // final_candidate : 6,
    // onboard : 7,
    // collaborator : 8,
    // offer : 9,
    // scheduled_by_hr : 10,
    // hr_interview : 11,
    // scheduled_by_boss : 12,
    // boss_interview : 13,